enum ConsultProtocolTypeEnum {
	SAC = 'SAC',
	OUVIDORIA = 'OUVIDORIA',
	FINANCEIRO = 'FINANCEIRO',
	ATENDIMENTO = 'ATENDIMENTO',
}

enum ConsultProtocolPacmanEnum {
	MOTIVO_8 = 8,
	MOTIVO_56 = 56,
}

type ConsultProtocolsItem = {
	nuRegistro: number;
	dtAtendimento: string;
	dtEncerramento: string | null;
	observacao: string | null;
	retorno: string | null;
	registro: string;
	motivo: number | null;
	motivoDescricao: string | null;
	assunto: number | null;
	assuntoDescricao: string | null;
	status: number;
	statusDescricao: string;
	tipoProtocolo: string | ConsultProtocolTypeEnum;
};

type Status = {
	statusId: string;
	statusDescricao: string;
};

type ConsultProtocolResponse = {
	protocolos: ConsultProtocolsItem[];
	tiposProtocolos: string[];
	tiposStatus: Status[];
	totalItems: number;
	itemsPerPage: number;
};

type ConsultProtocolsParams = {
	initialDate: string;
	finalDate: string;
	signal?: AbortSignal;
};

type GetConsultProtocolsModel = ConsultProtocolResponse;

interface GetConsultProtocols {
	get: (params: ConsultProtocolsParams) => Promise<GetConsultProtocolsModel>;
}

export type {
	ConsultProtocolsItem,
	ConsultProtocolsParams,
	GetConsultProtocolsModel,
	GetConsultProtocols,
	Status,
};

export {ConsultProtocolTypeEnum, ConsultProtocolPacmanEnum};
